import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import StallBookingListLayer from "../components/StallBookingListLayer";

const StallBookingListPage = () => {
    return (
        <MasterLayout>
            <StallBookingListLayer />
        </MasterLayout>
    );
};

export default StallBookingListPage;
